'use client'

import React from 'react'
import Image, { ImageProps } from 'next/image'
import Link from 'next/link'
import styles from './ActionImage.module.css'
import classNames from 'classnames'

export interface ActionImageProps extends Omit<ImageProps, 'className'> {
  href?: string
  actionText?: string
  className?: string
  containerClassName?: string
  showActionArrow?: boolean
  actionIcon?: React.ReactNode
}

export const ActionImage = ({
  href,
  actionText = 'READ MORE',
  className = '',
  containerClassName = '',
  showActionArrow = true,
  actionIcon,
  alt,
  ...imageProps
}: ActionImageProps) => {
  // Create the image element with hover effect
  const imageElement = (
    <div className={classNames(styles.container, containerClassName)}>
      <div className={styles.imageWrapper}>
        <Image className={classNames(styles.image, className)} alt={alt || 'Image'} {...imageProps} loading="lazy" />
        <div className={styles.bottomLine}></div>
        <div className={styles.actionContainer}>
          <span className={styles.actionText}>
            {showActionArrow && !actionIcon && (
              <span className={styles.arrow}>
                <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19.7276 6.33109L13.776 0.27703C13.4128 -0.0923434 12.8239 -0.0923434 12.4608 0.27703C12.0976 0.646479 12.0976 1.24538 12.4608 1.61483L16.8249 6.05404H0.929949C0.416394 6.05404 0 6.4776 0 6.99999C0 7.5223 0.416394 7.94594 0.929949 7.94594H16.8249L12.4609 12.3852C12.0977 12.7546 12.0977 13.3535 12.4609 13.723C12.6425 13.9075 12.8805 14 13.1185 14C13.3565 14 13.5945 13.9075 13.7761 13.723L19.7276 7.66889C20.0908 7.29944 20.0908 6.70054 19.7276 6.33109Z"
                    fill="#101010"
                  />
                </svg>
              </span>
            )}
            {actionIcon && <span className={styles.actionIcon}>{actionIcon}</span>}
            {actionText}
          </span>
        </div>
      </div>
    </div>
  )

  // If href is provided, wrap the image in a Link
  if (href) {
    return (
      <Link href={href} className={styles.link}>
        {imageElement}
      </Link>
    )
  }

  // Otherwise, just return the image element
  return imageElement
}

export default ActionImage
